import { createSlice } from "@reduxjs/toolkit";

import {
  getRevenueRecognationThunk,
  createRevenueRecognationThunk,
  updateRevenueRecognationThunk,
  deleteRevenueRecognationThunk,
  verifyRevenueRecognationThunk,
} from "state/action/revenue_recognation";

// Initial state
const initialState = {
  // Get RevenueRecognation inisial state
  getRevenueRecognation: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create RevenueRecognation inisial state
  createRevenueRecognation: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update RevenueRecognation inisial state
  updateRevenueRecognation: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update RevenueRecognation inisial state
  verifyRevenueRecognation: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete RevenueRecognation inisial state
  deleteRevenueRecognation: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },

  createRevenueRecognationInputBody: {
    code: "",
    RevenueRecognation_name: "",
    division: "",
    description: "",
  },
  selectedRevenueRecognation: {
    revenue_recognation: [],
    overall_status: "",
    verifications: [],
    pks: "",
  },
  verifyRevenueRecognationInputBody: {
    id: "",
    role: "",
    status: "",
    notes: "",
    user_id: "",
  },

  // RevenueRecognation object value
  revenueRecognation_object_value: "",
};

export const revenueRecognationSlice = createSlice({
  name: "revenueRecognation",
  initialState,
  reducers: {
    setGetRevenueRecognationObjectValue: (state, action) => {
      return {
        ...state,
        RevenueRecognation_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetRevenueRecognationObjectValue: (state, _) => {
      return {
        ...state,
        RevenueRecognation_object_value: "",
      };
    },
    setCreateRevenueRecognationInputBody: (state, action) => {
      return {
        ...state,
        createRevenueRecognationInputBody: action.payload,
      };
    },
    setVerifyRevenueRecognationInputBody: (state, action) => {
      return {
        ...state,
        verifyRevenueRecognationInputBody: action.payload,
      };
    },
    setSelectedRevenueRecognation: (state, action) => {
      return {
        ...state,
        selectedRevenueRecognation: action.payload,
      };
    },
    setClearCreateRevenueRecognationInputBody: (state, _) => {
      return {
        ...state,
        createRevenueRecognationInputBody: {
          code: "",
          revenueRecognation_name: "",
          division: "",
          description: "",
        },
      };
    },
    setClearCreateRevenueRecognation: (state, _) => {
      return {
        ...state,
        createRevenueRecognation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearGetRevenueRecognation: (state, _) => {
      return {
        ...state,
        getRevenueRecognation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateRevenueRecognation: (state, _) => {
      return {
        ...state,
        updateRevenueRecognation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteRevenueRecognation: (state, _) => {
      return {
        ...state,
        deleteRevenueRecognation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllRevenueRecognationState: (state, _) => {
      return {
        ...state,
        // Get RevenueRecognation inisial state
        getRevenueRecognation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create RevenueRecognation inisial state
        createRevenueRecognation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update RevenueRecognation inisial state
        updateRevenueRecognation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete RevenueRecognation inisial state
        deleteRevenueRecognation: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // RevenueRecognation object value
        RevenueRecognation_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get RevenueRecognation reducer
      .addCase(getRevenueRecognationThunk.pending, (state, _) => {
        return {
          ...state,
          getRevenueRecognation: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getRevenueRecognationThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getRevenueRecognation: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getRevenueRecognationThunk.rejected, (state, action) => {
        return {
          ...state,
          getRevenueRecognation: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create RevenueRecognation reducer
      .addCase(createRevenueRecognationThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createRevenueRecognationThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createRevenueRecognationThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update RevenueRecognation reducer
      .addCase(updateRevenueRecognationThunk.pending, (state, _) => {
        return {
          ...state,
          updateRevenueRecognation: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateRevenueRecognationThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateRevenueRecognation: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateRevenueRecognationThunk.rejected, (state, action) => {
        return {
          ...state,
          updateRevenueRecognation: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      .addCase(verifyRevenueRecognationThunk.pending, (state, _) => {
        return {
          ...state,
          verifyRevenueRecognation: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(verifyRevenueRecognationThunk.fulfilled, (state, action) => {
        return {
          ...state,
          verifyRevenueRecognation: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(verifyRevenueRecognationThunk.rejected, (state, action) => {
        return {
          ...state,
          verifyRevenueRecognation: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const revenueRecognationAction = {
  ...revenueRecognationSlice.actions,
  getRevenueRecognationThunk,
  createRevenueRecognationThunk,
  updateRevenueRecognationThunk,
  deleteRevenueRecognationThunk,
  verifyRevenueRecognationThunk,
};

export function selectRevenueRecognationObjectValue(state) {
  return state?.revenueRecognation?.revenueRecognation_object_value;
}

export function selectRevenueRecognation(state) {
  return state?.revenueRecognation;
}

export default revenueRecognationSlice.reducer;
